class AttendanceMinutesCalculationUtils {
  /**
   * Calculates balanced regular minutes following the next formula:
   * balancedRegularMinutes = regularMinutes + (approvedWorkedExtraMinutes - extraHoursMinutesFromBalance)
   * This transforms the approved extra time minutes into balanced regular minutes if they don't match the extra hours minutes from balance.
   *
   * @param regularMinutes - Regular minutes from backend
   * @param approvedWorkedExtraMinutes - Approved extra time minutes
   * @param extraHoursMinutesFromBalance - Extra hours from balance calculation
   * @returns Balanced regular minutes
   */
  static calculateBalancedRegularMinutes({
    regularMinutes,
    approvedWorkedExtraMinutes,
    extraHoursMinutesFromBalance,
  }: {
    regularMinutes: number
    approvedWorkedExtraMinutes: number
    extraHoursMinutesFromBalance: number
  }): number {
    const balanced = regularMinutes + (approvedWorkedExtraMinutes - extraHoursMinutesFromBalance)
    return Math.max(balanced, 0)
  }
}

export default AttendanceMinutesCalculationUtils
